import { render, staticRenderFns } from "./PreRegistro.vue?vue&type=template&id=f1dd9c2e&"
import script from "./PreRegistro.vue?vue&type=script&lang=js&"
export * from "./PreRegistro.vue?vue&type=script&lang=js&"
import style0 from "./PreRegistro.vue?vue&type=style&index=0&id=f1dd9c2e&prod&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports